const STORAGE_KEY = 'cs-data-passwords';

const readPasswords = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

const writePasswords = (passwords) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(passwords));
    } catch {
        // Ignore storage write failures and fall back to prompting again.
    }
};

export const getDownloadPassword = (idx) => {
    if (!idx) {
        return '';
    }

    const passwords = readPasswords();
    return passwords[String(idx)] || '';
};

export const setDownloadPassword = (idx, password) => {
    if (!idx || !password) {
        return;
    }

    const passwords = readPasswords();
    passwords[String(idx)] = password;
    writePasswords(passwords);
};

export const removeDownloadPassword = (idx) => {
    if (!idx) {
        return;
    }

    const passwords = readPasswords();
    delete passwords[String(idx)];
    writePasswords(passwords);
};
